import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from './TakePhoto';

import '../../../../css/qavaApp.css';

export function AddSupplierModal (props) {


    let supplierNameRef = useRef('Terry');
    let supplierPhoneRef = useRef('245346569');
    let supplierEmailAddressRef = useRef('tkweifio@live.com');
    let supplierAddressNumberRef = useRef('55');
    let supplierStreetNameRef = useRef('Social Welfare Rd');

    let supplierCityRef = useRef('Somanya');
    let supplierCityDistrictRef = useRef('Eastern');
    let supplierCountryRegionRef = useRef('Ghana');
    let supplierCountryRef = useRef('Korledgen');
    let supplierDigitalAddressIDRef = useRef('dsaaf');


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);

    /*useEffect(() => {

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/png',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setSelectedFile(noImageFile);
        })

    }, []);*/

    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            //alert('After attachement Response');
            //alert(data);

            const blobUrl = URL.createObjectURL(data);

            //alert(blobUrl);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/png',
                name: 'xImageFile',
                accept: "image/*",
            });

            //alert(noImageFile);
            
            setSelectedFile(noImageFile);

            alert("No Attachment Option checked");

        })
    }



    function addSupplier(enteredPassword)
    {
        alert("In Add Supplier");
        alert(selectedFile);
        
        let formData = new FormData();
        formData.append('Tracker', '74002S');
        formData.append('user', acctID);
        formData.append('xSupplierName', supplierNameRef.current.value);
        formData.append('xSupplierPhoneNumber', supplierPhoneRef.current.value);
        formData.append('xSupplierEmailAddress', supplierEmailAddressRef.current.value);
        formData.append('xSupplierAddressNumber', supplierAddressNumberRef.current.value);
        formData.append('xSupplierStreetName', supplierStreetNameRef.current.value);
        formData.append('xSupplierCity', supplierCityRef.current.value);
        formData.append('xSupplierCityDistrict', supplierCityDistrictRef.current.value);
        formData.append('xSupplierCountryRegion', supplierCountryRegionRef.current.value);
        formData.append('xSupplierCountry', supplierCountryRef.current.value);
        formData.append('xSupplierDigitalAddressID', supplierDigitalAddressIDRef.current.value);
        formData.append('xEnterAdminPassword', enteredPassword);
        formData.append('sessionID', sessionID);
        formData.append('xImageFile', selectedFile);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        /*const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            file: selectedFile,
            body: JSON.stringify({
                Tracker: '74002S',
                user: acctID,
                xSupplierName: supplierNameRef.current.value,
                xSupplierPhoneNumber: supplierPhoneRef.current.value,
                xSupplierEmailAddress: supplierEmailAddressRef.current.value,
                xSupplierAddressNumber: supplierAddressNumberRef.current.value,
                xSupplierStreetName: supplierStreetNameRef.current.value,
                xSupplierCity: supplierCityRef.current.value,
                xSupplierCityDistrict: supplierCityDistrictRef.current.value,
                xSupplierCountryRegion: supplierCountryRegionRef.current.value,
                xSupplierCountry: supplierCountryRef.current.value,
                xSupplierDigitalAddressID: supplierDigitalAddressIDRef.current.value,
                //xImageFile: selectedFile,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
            }),

        }*/

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    /*function takePhotoHandler() {

        alert('In takePhotoHandler');

        setTakePhotoStatus(true);

        //const { takePhoto, photos } = TakePhoto();

        alert('In takePhotoHandler After TakePhoto');

        //alert(photos);
        //alert(photos[0]);
        //alert(photos[0].webviewPath);

        //setSelectedFile(photos[0].webviewPath);
    }*/

    function selectedFileHandler(event)
    {
        alert('In onSelectedFile');

        alert(event);
        
        //alert(Object.entries(event));
        //alert(Object.entries(event.exif));

        /*let expenseObject = {
            enctype: 'multipart/form-data',
            type: 'file',
            name: 'xImageFile',
            accept: "image/*",
            filename: event,

        }*/

        setSelectedFile(event);

    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');
        //alert(enteredPassword);

        //setEnteredPassword(event);
        addSupplier(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonContent className='bookedDetails_gridContent_multiple'>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Name: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter Supplier Name' ref={ supplierNameRef } value='Terry Quaye'></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Phone Number: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter Supplier Phone Number' ref={ supplierPhoneRef } value='0245346569'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Email: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter email' ref={ supplierEmailAddressRef } value='tkweifio@live.com'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Address Number: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter address number' ref={ supplierAddressNumberRef } value='76'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Street Name: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter street name' ref={ supplierStreetNameRef } value='Social Welfare Rd'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier City: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter city' ref={ supplierCityRef } value='Somanya'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier City District: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter Digital city district' ref={ supplierCityDistrictRef } value='Korledjen'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Country Region: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter country region' ref={ supplierCountryRegionRef } value='Eastern'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Country: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter country' ref={ supplierCountryRef } value='Ghana'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Supplier Digital Address ID: </IonLabel>
                                    </IonCol>
                                    <IonCol>
                                        <IonInput type='text' placeholder='Enter Digital Address' ref={ supplierDigitalAddressIDRef } value='EDF-48422'></IonInput>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonSlide>
                        <IonSlide>
                            <IonGrid>
                               {/*} <IonRow>
                                    <IonCol>
                                        <h3>Upload</h3>
                                    </IonCol>
                                    <IonCol>                                        
                                        <form id='fileUpload' onSubmit={() => setShowPasswordModal(true)}>
                                            <input type='file' name='xImageFile' accept="image/*" enctype='multipart/form-data' onChange={(e) => setSelectedFile(e.target.files[0])}></input>
                                        </form>
                                    </IonCol>
                </IonRow>*/}
                                <IonRow>
                                    <IonCol>
                                        <h4 >Take Phote</h4>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton  onClick={() => setTakePhotoStatus(true)}> Click</IonButton>
                                        {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol> 
                                        <h4 >No Attachment</h4>
                                    </IonCol>
                                    <IonCol>
                                        <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement()}></input>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                       {/*<IonButton onClick={() => setShowPasswordModal(true)}> Add Supplier </IonButton>*/}
                                        <IonButton onClick={() => addSupplier('reaper')}> Add Supplier </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>                        

                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                    </IonContent>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}